export default __webpack_public_path__ + "static/media/auteuil6.33347f52.jpg";